var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckToastRefferal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 39,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#80D1CD",
  d: "m19.627 17.72-5.72 5.733-2.2-2.2a1.333 1.333 0 1 0-1.88 1.88l3.133 3.147a1.334 1.334 0 0 0 1.88 0l6.667-6.667a1.33 1.33 0 0 0 0-1.893 1.334 1.334 0 0 0-1.88 0M16 8.667a13.334 13.334 0 1 0 0 26.667 13.334 13.334 0 0 0 0-26.667m0 24a10.667 10.667 0 1 1 0-21.334 10.667 10.667 0 0 1 0 21.334"
})));
export default SvgCheckToastRefferal;